var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "check") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4741201,8.31285888 L10.2691511,14.4413924 L8.57763975,12.508972 C8.20151829,12.0769379 7.54658385,12.0341486 7.11663216,12.4109706 C6.68668047,12.7877926 6.64320221,13.4413648 7.01932367,13.8713284 L9.43478261,16.6319291 C9.62318841,16.847256 9.89095928,16.9749337 10.1759834,16.985286 C10.1890959,16.9859761 10.2015183,16.9859761 10.2139406,16.9859761 C10.4858523,16.9859761 10.747412,16.8790029 10.9413389,16.6871411 L17.9289165,9.78563936 C18.3360939,9.38397195 18.3395445,8.72832928 17.9378882,8.32183083 C17.5362319,7.91395208 16.8812974,7.91119148 16.4741201,8.31285888 M22.9296066,21.204174 C22.9296066,22.1558911 22.1552795,22.9295495 21.2042788,22.9295495 L3.79572119,22.9295495 C2.8447205,22.9295495 2.07039337,22.1558911 2.07039337,21.204174 L2.07039337,3.79582597 C2.07039337,2.84479903 2.8447205,2.07045053 3.79572119,2.07045053 L21.2042788,2.07045053 C22.1552795,2.07045053 22.9296066,2.84479903 22.9296066,3.79582597 L22.9296066,21.204174 Z M21.2042788,0 L3.79572119,0 C1.70324362,0 0,1.70260049 0,3.79582597 L0,21.204174 C0,23.2967094 1.70324362,25 3.79572119,25 L21.2042788,25 C23.2974465,25 25,23.2967094 25,21.204174 L25,3.79582597 C25,1.70260049 23.2974465,0 21.2042788,0 L21.2042788,0 Z",
    id: "check",
    fill: "#179E5A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.f685f8bec0a81b62aed7d93a36da917b.svg";
export { ForwardRef as ReactComponent };